import { Flex, Text, Button } from "@chakra-ui/react";
import { AlertCircle, RotateCcw } from "lucide-react";
import React from "react";

interface EnvironmentalVariablesErrorStateProps {
  errorMessage: string;
  retryLabel: string;
  onRetry: () => void;
}

export const EnvironmentalVariablesErrorState: React.FC<EnvironmentalVariablesErrorStateProps> =
  ({ errorMessage, retryLabel, onRetry }) => (
    <Flex
      direction="column"
      align="center"
      justify="center"
      py={8}
      px={4}
      bg="#f4f4f5"
      borderRadius={8}
      gap={3}
    >
      <AlertCircle size={32} color="#E53E3E" />
      <Text fontSize="sm" color="#4A5568" textAlign="center">
        {errorMessage}
      </Text>
      <Button
        size="sm"
        variant="outline"
        borderColor="#086AA9"
        color="#086AA9"
        leftIcon={<RotateCcw size={14} />}
        onClick={onRetry}
        _hover={{ bg: "rgba(8, 106, 169, 0.1)" }}
      >
        {retryLabel}
      </Button>
    </Flex>
  );
